export const contactNum = {
  HK: 'tel:(852) 2533 5555',
  MO: 'tel:(853) 2832 2622'
}

// 200009: session过期, 200010: session无效, 200016: session被踢， 200026: 用户解绑
export const sessionCode = [200009, 200010, 200016, 200026]

// tradeSession 失效
export const tradeSessionCode = [200414, 200415, 1895]

// 顾问服务过期
export const csAppExpiredCode = 200027

// FPSNo校验错误
export const FPSnoErrorCode = 200511

// 银行维护错误
export const bankErrorCode = 200512

// 未通过万通校验，无法提交
export const cannotSubmitErrorCode = 200500

// 手机号/邮箱等提交格式错误
export const invalidFormat = 200031

// 支付结果
export const paymentResult = {
  success: 'success',
  fail: 'fail',
  cancel: 'cancel',
  paramsError: 'paramsError'
}

// toask UI样式， 0:正常-蓝色， 1:用户错误反馈-灰色， 2:系统错误反馈-红色
export const toastType = {
  normal: 0,
  error: 1,
  fatal: 2
}

// 客户类型
export const clientType = {
  unlogin: '0',
  nobind: '1',
  prouser: '2',
  binded: '3'
}

// 文件类型
export const fileType = {
  1: 'letter',
  2: 'insureFile',
  3: 'policy'
}

// 我的文件--筛选类型
export const filterType = {
  TIME: 'time',
  TYPE: 'type',
  PLAN: 'plan',
  NEWEST: 'newest',
  NAME: 'name'
}

// 我的EB文件--筛选类型
export const filterEBType = {
  TIME: 'time',
  TYPE: 'type'
}

// 我的MPF文件--筛选类型
export const filterMPFType = {
  TIME: 'time',
  TYPE: 'newest'
}

//  地区区号
export const areaCode = {
  HK: '852', // 香港
  MC: '853', // 澳门
  MO: '853', // 澳门
  CN: '86', // 大陆
  TW: '886', // 台湾
  JP: '81', // 日本
  GB: '44', // 英国
  SG: '65', // 新加坡
  AU: '61', // 澳洲
  US: '1', // 美国
  CA: '1', // 加拿大
  OTHER: '' // 其它
}

// MPF更改资料--类型
export const updateMPFType = {
  NAME: 'name',
  EMAIL: 'email',
  TEL: 'tel',
  ADDRESS: 'address'
}
